import { Box, Grid, Card, CardActionArea, CardMedia, Typography, Button } from "@mui/material";

const InactiveCategoriesProductsTab = ({
  products,
  isAr,
  sortOrder,
  getName,
  getDesc,
  getImg,
  onOpenDetails,
  onOpenEdit,
  onOpenDelete,
}) => {
  if (!Array.isArray(products) || products.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography color="text.secondary">لا توجد منتجات لفئات غير نشطة</Typography>
      </Box>
    );
  }

  const createdAtValue = (value) => {
    if (!value) return 0;
    const parsed = new Date(value).getTime();
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const sortByCreatedAt = (list = [], order = "desc") => {
    if (!Array.isArray(list)) return [];
    return [...list].sort((a, b) => {
      const diff = createdAtValue(b?.created_at) - createdAtValue(a?.created_at);
      return order === "asc" ? -diff : diff;
    });
  };

  const grouped = products.reduce((acc, p) => {
    const catId = p.categroy?.id ?? "uncategorized";
    const catName = isAr
      ? p.categroy?.name_ar || p.categroy?.name_en || "غير مصنف"
      : p.categroy?.name_en || p.categroy?.name_ar || "Uncategorized";

    if (!acc[catId]) {
      acc[catId] = {
        id: catId,
        name: catName,
        created_at: p?.categroy?.created_at || null,
        items: [],
      };
    }
    acc[catId].items.push(p);
    return acc;
  }, {});

  const sortedGroups = sortByCreatedAt(Object.values(grouped), sortOrder);

  return (
    <>
      {sortedGroups.map((group) => (
        <Box key={group.id} sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
            {group.name}
          </Typography>

          <Grid container spacing={3}>
            {sortByCreatedAt(group.items, sortOrder).map((p) => (
              <Grid item xs={12} sm={6} md={3} key={p.id}>
                <Card sx={{ height: "100%", transition: "transform .18s", "&:hover": { transform: "translateY(-6px)", boxShadow: 4 } }}>
                  <CardActionArea onClick={() => onOpenDetails(p.id)} sx={{ textAlign: isAr ? "right" : "left", cursor: "pointer" }}>
                    <CardMedia component="img" image={getImg(p)} alt={getName(p)} sx={{ height: 160, objectFit: "cover", backgroundColor: "#f5f5f5" }} />
                    <Box sx={{ p: 2 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {getName(p)}
                      </Typography>

                      {getDesc(p) ? (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                          {getDesc(p)}
                        </Typography>
                      ) : null}

                      {p.categroy && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                          {isAr ? p.categroy.name_ar : p.categroy.name_en}
                        </Typography>
                      )}

                      <Box sx={{ mt: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            onOpenEdit(p);
                          }}
                        >
                          تعديل
                        </Button>
                        <Button
                          size="small"
                          color="error"
                          variant="outlined"
                          sx={{ ml: 1 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            onOpenDelete(p);
                          }}
                        >
                          حذف
                        </Button>
                      </Box>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </>
  );
};

export default InactiveCategoriesProductsTab;
